// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#tooltip-wrapper[data-v-7ba5bd90] {\n  position: fixed;\n  z-index: 99999;\n}\n#modal-wrapper[data-v-7ba5bd90] {\n  position: fixed;\n  z-index: 9999;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
